module.exports = __webpack_public_path__ + "img/06加入我们.a0380840.png";